import {
  FETCH_STUDENT,
  FETCH_PARENT,
  FETCH_CORRECTION_SUMMARIES,
  FETCH_BIO_INFO,
  FETCH_STUDENT_PARAMETERS,
  FETCH_INTERVIEW_LINKS,
  FETCH_INTERVIEW_LINKS_ALL,
  FETCH_INTERVIEW_LINKS_HISTORY,
  FETCH_STUDENT_ALERTS,
  FETCH_STUDENT_MEMOS,
  SET_STUDENT_ACCOUNTS,
  FETCH_SIGNATURE_ALLOWANCE,
  RESET_SIGNATURE_ALLOWANCE,
  FETCH_STUDENT_PROCESSOR_DOCUMENTS,
  FETCH_COMMENT_CODE_INFOS,
  FETCH_COMMENT_CODE_LINKS, 
  RESET_STUDENT,
  FETCH_STUDENT_ATTRIBUTES
} from "./types";
import StudentService from "../services/StudentService";
import AlertService from "../services/AlertService";
import InterviewService from "../services/InterviewService";

export const fetchNewStudent = (student, uuid) => {
  return async dispatch => {
    dispatch({ type: RESET_STUDENT, payload: {} });
    const response = student !== null ? student : await StudentService.getStudent(uuid);
    if(!response){
      let errorMessage = "No response from fetch student";
      console.log(errorMessage);
      AlertService.addErrorAlert(errorMessage);
    } else if (response.message) {
      console.log(response.message);
      AlertService.addErrorAlert(response.message);
    } else {
      dispatch({ type: FETCH_STUDENT, payload: response });
    }
  };
};

export const fetchStudent = uuid => {
  return async dispatch => {
    const response = await StudentService.getStudent(uuid);
    if(!response){
      let errorMessage = "No response from fetch student";
      console.log(errorMessage);
      AlertService.addErrorAlert(errorMessage);
    } else if (response.message) {
      console.log(response.message);
      AlertService.addErrorAlert(response.message);
    } else {
      dispatch({ type: FETCH_STUDENT, payload: response });
    }
  };
};

export const fetchParent = studentId => {
  return async dispatch => {
    const response = await StudentService.getParentProfile(studentId);
    if(!response){
      let errorMessage = "No response from fetch parent";
      console.log(errorMessage);
      AlertService.addErrorAlert(errorMessage);
    } else if (response.message) {
      console.log(response.message);
      AlertService.addErrorAlert(response.message);
    } else {
      dispatch({ type: FETCH_PARENT, payload: response });
    }
  };
};

export const fetchStudentAttributes = studentId => {
  return async dispatch => {
    const response = await StudentService.getStudentAttribute(studentId);
    if(!response){
      let errorMessage = "No response from fetch student attributes";
      console.log(errorMessage);
      AlertService.addErrorAlert(errorMessage);
    } else if (response.message) {
      console.log(response.message);
      AlertService.addErrorAlert(response.message);
    } else {
      dispatch({ type: FETCH_STUDENT_ATTRIBUTES, payload: response });
    }
  };
};

export const fetchStudentMemos = uuid => {
  return async dispatch => {
    const response = await StudentService.getStudentMemos(uuid);
    if(!response){
      let errorMessage = "No response from fetch student memos";
      console.log(errorMessage);
      AlertService.addErrorAlert(errorMessage);
    } else if (response.message) {
      console.log(response.message);
      AlertService.addErrorAlert(response.message);
    } else {
      dispatch({ type: FETCH_STUDENT_MEMOS, payload: response });
    }
  };
};

export const fetchStudentAlerts = uuid => {
  return async dispatch => {
    const response = await StudentService.getStudentAlerts(uuid);
    if(!response){
      let errorMessage = "No response from fetch student alerts";
      console.log(errorMessage);
      AlertService.addErrorAlert(errorMessage);
    } else if (response.message) {
      console.log(response.message);
      AlertService.addErrorAlert(response.message);
    } else {
      dispatch({ type: FETCH_STUDENT_ALERTS, payload: response });
    }
  };
};

export const fetchStudentProcessorDocuments = id => {
  return async dispatch => {
    const response = await StudentService.getAllProcessorDocuments(id);
    if(!response){
      let errorMessage = "No response from fetch student processor documents";
      console.log(errorMessage);
      AlertService.addErrorAlert(errorMessage);
    } else if (response.message) {
      console.log(response.message);
      AlertService.addErrorAlert(response.message);
    } else {
      dispatch({ type: FETCH_STUDENT_PROCESSOR_DOCUMENTS, payload: response });
    }
  };
};

export const fetchCorrectionSummaries = studentID => {
  return async dispatch => {
    StudentService.getCorrectionSummaries(studentID).then(response => {
      if(!response){
        let errorMessage = "No response from fetch correction summaries";
        console.log(errorMessage);
        AlertService.addErrorAlert(errorMessage);
      } else if (response.message) {
        console.log(response.message);
        AlertService.addErrorAlert(response.message);
      } else {
        dispatch({ type: FETCH_CORRECTION_SUMMARIES, payload: response });
      }
    });
  };
};

export const fetchBioInfo = (studentAccountID, studentID) => {
  return async dispatch => {
    StudentService.getBioInfo(studentAccountID, studentID).then(response => {
      if(!response){
        let errorMessage = "No response from fetch bio info";
        console.log(errorMessage);
        AlertService.addErrorAlert(errorMessage);
      } else if (response.message) {
        console.log(response.message);
        AlertService.addErrorAlert(response.message);
      } else {
        dispatch({ type: FETCH_BIO_INFO, payload: response });
      }
    });
  };
};

export const fetchStudentParameters = studentID => {
  return async dispatch => {
    InterviewService.getStudentParameters(studentID).then(response => {
      dispatch({ type: FETCH_STUDENT_PARAMETERS, payload: response });
    });
  };
};

export const fetchInterviewLinks = (studentID, aidYear) => {
  return async dispatch => {
    StudentService.taskListSearch({ studentID: studentID, aidYear: aidYear }).then(response => {
      const interviewLinks = response.filter(x => (x.studentInterviewLinkStatus !== "AUTO_VERIFIED" && x.studentInterviewLinkStatus !== "NOT_REQUIRED"));
      dispatch({ type: FETCH_INTERVIEW_LINKS, payload: interviewLinks });
    });
  };
};

export const fetchInterviewLinksAll = (studentID, aidYear) => {
  return async dispatch => {
    await StudentService.taskListSearch({ studentID: studentID, aidYear: aidYear }).then(response => {
      dispatch({ type: FETCH_INTERVIEW_LINKS_ALL, payload: response });
    });
  };
};

export const fetchInterviewLinksHistory = uuid => {
  return async dispatch => {
    await InterviewService.getStudentInterviewHistory(uuid).then(response => {
      if(!response){
        let errorMessage = "No response from fetch interview links history";
        console.log(errorMessage);
        AlertService.addErrorAlert(errorMessage);
      } else if (response.message) {
        console.log(response.message);
        AlertService.addErrorAlert(response.message);
      } else {
        dispatch({ type: FETCH_INTERVIEW_LINKS_HISTORY, payload: response });
      }
    });
  };
};

export const clearInterviewLinks = studentID => {
  return async dispatch => {
    dispatch({ type: FETCH_INTERVIEW_LINKS, payload: null });
  };
};

export const clearInterviewLinksAll = studentID => {
  return async dispatch => {
    dispatch({ type: FETCH_INTERVIEW_LINKS_ALL, payload: null });
  };
};

export const clearInterviewLinksHistory = uuid => {
  return async dispatch => {
    dispatch({ type: FETCH_INTERVIEW_LINKS_HISTORY, payload: null });
  };
};

export const fetchStudentAccounts = uuid => {
  return async dispatch => {
    let studentAccount = null;
    let parentAccount = null;
    let otherParentAccount = null;
    let spouseAccount = null;
    let studentAccountLink = null;
    let parentAccountLink = null;
    let otherParentAccountLink = null;
    let spouseAccountLink = null;
    const response = await StudentService.getStudentAccountsByUUID(uuid);    
    if (response) {
      let accountLinks = await StudentService.getManyStudentAccountLink({studentIDs: response[0].studentList.map(x => x.id), studentAccountIDs: null }); 
        response.forEach(async n => {
          let accountLink = accountLinks.filter(a => a.studentAccountID === n.id)[0];
          if (accountLink.accountType === 0) {
            studentAccount = n;
            studentAccountLink = accountLink;
          } else if (accountLink.accountType === 1) {
            parentAccount = n;
            parentAccountLink = accountLink;
          } else if (accountLink.accountType === 3) {
            otherParentAccount = n;
            otherParentAccountLink = accountLink;
          } else if (accountLink.accountType === 4) {
            spouseAccount = n;
            spouseAccountLink = accountLink;
          }
        });
      };
    // Dispatch a synchronous redux action
    dispatch({
      type: SET_STUDENT_ACCOUNTS,
      payload: {
        studentAccount: studentAccount,
        parentAccount: parentAccount,
        otherParentAccount: otherParentAccount,
        spouseAccount: spouseAccount,
        studentAccountLink: studentAccountLink,
        parentAccountLink: parentAccountLink,
        otherParentAccountLink: otherParentAccountLink,
        spouseAccountLink: spouseAccountLink
      }
    });
  }
};

export const fetchSignatureAllowance = (uuid, isForParent) => {
  return async dispatch => {
    StudentService.getSignatureStatus(uuid, isForParent).then(response => {
      if(!response){
        let errorMessage = "No response from fetch signature allowance";
        console.log(errorMessage);
        AlertService.addErrorAlert(errorMessage);
      } else if (response.message) {
        console.log(response.message);
        AlertService.addErrorAlert(response.message);
      } else {
        dispatch({ type: FETCH_SIGNATURE_ALLOWANCE, payload: response });
      }
    });
  };
};

export const fetchCommentCodeInfos = () => {
  return async dispatch => {
    StudentService.getAllCommentCodeInfo().then(response => {
      if(!response){
        let errorMessage = "No response from fetch comment code infos";
        console.log(errorMessage);
        AlertService.addErrorAlert(errorMessage);
      } else if (response.message) {
        console.log(response.message);
        AlertService.addErrorAlert(response.message);
      } else {
        dispatch({ type: FETCH_COMMENT_CODE_INFOS, payload: response });
      }
    })
  }
}

export const fetchCommentCodeLinks = uuid => {
  return async dispatch => {
    StudentService.getStudentCommentCodeLinksByUUID(uuid).then(response => {
      if (response.message) {
        console.log(response.message);
        AlertService.addErrorAlert(response.message);
      } else {
        dispatch({ type: FETCH_COMMENT_CODE_LINKS, payload: response });
      }
    });
  };
};

export const resetSignatureAllowance = () => {
  return { type: RESET_SIGNATURE_ALLOWANCE };
};
